import FormText from "components/form/FormText";
import IndicatorButton from "components/indicator/IndicatorButton";
import { AppHelper } from "helpers/appHelper";
import { useApiState } from "hooks/useApiState";
import { useState } from "react";
import { useErrorBoundary } from "react-error-boundary";
import { useForm } from "react-hook-form";
import ReactModal from "react-modal";
/**
 * ベンチマークコンタクトリストID設定モーダル
 */
export default function WsModalReportTerm(props: {
  setOpen: (open: boolean) => void;
  open: boolean;
  apiKey: string;
  contactListId: string;
  onSubmit: (attr: { contactListId: string }) => void;
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */
  type FormStateType = {
    contactListId: string;
  };

  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const { showBoundary } = useErrorBoundary();

  const { postBenchmarkConnectionValid } = useApiState();

  const [processing, setProcessing] = useState(false);
  const [initialized, setInitialized] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    setError,
    formState: { errors },
  } = useForm<FormStateType>();

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * モーダルを閉じた時の処理
   */
  const onClose = () => {
    setInitialized(false);
    props.setOpen(false);
  };

  /**
   * モーダルが開いた後の処理
   */
  const onAfterOpen = () => {
    setValue("contactListId", props.contactListId);
    setInitialized(true);
  };

  /**
   * 設定ボタン押下時の処理
   */
  const onSubmit = () =>
    AppHelper.submit(
      processing,
      setProcessing,
      handleSubmit(async (data: FormStateType) => {
        try {
          // APIキーの空チェック
          if (AppHelper.isEmpty(props.apiKey)) {
            setError("contactListId", {
              type: "custom",
              message:
                "APIキーが設定されていません。管理者にお問い合わせください。",
            });
            return;
          }
          // コンタクトリストIDのチェック
          if (AppHelper.isNotEmpty(data.contactListId)) {
            const response = await postBenchmarkConnectionValid({
              apiKey: props.apiKey,
              contactListId: data.contactListId,
            });

            if (!response.valid) {
              setError("contactListId", {
                type: "custom",
                message: "APIキーとコンタクトリストIDの組み合わせが不正です。",
              });
              return;
            }
          }

          props.onSubmit({
            contactListId: data.contactListId,
          });

          // モーダルを閉じる
          onClose();
        } catch (e) {
          showBoundary(e);
        }
      })
    );

  /* ----------------------------------------------------------------------- */
  /* プライベート関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <ReactModal
        isOpen={props.open}
        onAfterOpen={onAfterOpen}
        onRequestClose={onClose}
        style={{
          overlay: {
            zIndex: 2000,
            backgroundColor: "rgba(30, 30, 30,0.5)",
          },
          content: {
            maxWidth: "500px",
          },
        }}
        className="ReactModal__Content__Custom"
        ariaHideApp={false}
      >
        {initialized && (
          <div
            id="settings-modal"
            className="modal2 modal-content rounded-4 "
            style={{ maxWidth: "none" }}
          >
            <div className="modal-header border-bottom-0">
              <button
                onClick={onClose}
                type="button"
                className="btn-close btn-circle-close"
              >
                <img src="/img/icon/multiply.svg" alt="x" />
              </button>
            </div>
            <div className="modal-body">
              <h3
                className="modal-title text-center mt-5"
                id="settings-modal-label"
              >
                Benchmarkの設定
              </h3>

              <div className="row justify-content-center align-items-center pt-3">
                <div className="col-10 col-md-10">
                  <label className="form-label">Benchmark APIキー</label>
                  {AppHelper.isNotEmpty(props.apiKey) && <p>{props.apiKey}</p>}
                  {AppHelper.isEmpty(props.apiKey) && (
                    <p className="error">
                      APIキーが設定されていません。カンパニー設定画面から登録してください。
                    </p>
                  )}
                </div>
              </div>

              <div className="row justify-content-center align-items-center pt-3">
                <div className="col-10 col-md-10">
                  <FormText
                    subject="コンタクトリストID"
                    name="contactListId"
                    errors={errors}
                    register={register}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer border-top-0 justify-content-center mt-4">
              <button
                onClick={onClose}
                type="button"
                className="btn btn-secondary"
              >
                キャンセル
              </button>
              <button
                onClick={onSubmit}
                type="button"
                disabled={AppHelper.isEmpty(props.apiKey) || processing}
                className="btn btn-submit"
              >
                <IndicatorButton visible={processing} />
                設定完了
              </button>
            </div>
          </div>
        )}
      </ReactModal>
    </>
  );
}
